import React from 'react';

// components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, FormGroup, Input, Row, Col } from "reactstrap";
import Select from 'react-select'

// style
import "../../../../assets/css/modal-cellphone.css"

export default function FormularioFichaModalPreVisualizacao({ isOpen, formularioVistoria, handleReturn }) {

    const handleComponentQuestao = (item) => {
        switch (item.tipoValor) {
            case "Texto":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
            case "Lista":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Select
                            name={item.identificacao}
                            options={item.formularioVistoriaQuestaoOpcos}
                            getOptionLabel={o => o.valor}
                            getOptionValue={o => o.valor}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                        />
                    </FormGroup>
                )
            case "Número":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="number"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
            case "Data":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="date"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
        }
    }

    const handleComponentCabecalho = (item) => {
        switch (item.tipoValor) {
            case "Texto":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
            case "Lista":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Select
                            name={item.identificacao}
                            options={item.formularioVistoriaCabecalhoOpcos}
                            getOptionLabel={o => o.valor}
                            getOptionValue={o => o.valor}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                        />
                    </FormGroup>
                )
            case "Número":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="number"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
            case "Data":
                return (
                    <FormGroup>
                        <label className="form-control-label">{item.identificacao}</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="date"
                            name={item.identificacao}
                        />
                    </FormGroup>
                )
        }
    }

    return (
        <>
            <Modal isOpen={isOpen} toggle={handleReturn} className="modal-cellphone">
                <ModalHeader cssModule={{ 'modal-title': 'w-100 text-center' }}><label className="autofalante"></label></ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12" className="text-center">
                            <h5>{formularioVistoria.identificacao}</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Button color="info" block>Cabeçalho</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    {formularioVistoria.formularioVistoriaCabecalhos && formularioVistoria.formularioVistoriaCabecalhos.sort(function(a,b) {return a.sequencia - b.sequencia}).map((m, key) => (
                                        <Row key={key}>
                                            <Col md="12">
                                                {handleComponentCabecalho(m)}
                                            </Col>
                                        </Row>
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>                        
                    </Row>
                    <Row>
                        <Col md="12">
                            <Button color="info" block>Questões</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    {formularioVistoria.formularioVistoriaQuestos && formularioVistoria.formularioVistoriaQuestos.sort(function(a,b) {return a.sequencia - b.sequencia}).map((m, key) => (
                                        <Row key={key}>
                                            <Col md="12">
                                                {handleComponentQuestao(m)}
                                            </Col>
                                        </Row>
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>                        
                        <Col md="12" className="text-center">
                            <Button color="success">Confirmar</Button>
                            <Button color="default">Cancelar</Button>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col md="12">
                            <div className="text-center"><i className="far fa-circle fa-3x btn-cellphone" onClick={handleReturn}></i></div>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </>
    );
}

